<template>
  <div class="leftjoin-root">
    <!-- 离屏预加载选点地图（单例容器，避免每次打开弹窗重复 new AMap.Map） -->
    <div ref="mapPrewarmWrap" class="leftjoin-map-prewarm" aria-hidden="true">
      <div ref="mapSingletonEl" class="leftjoin-map-singleton-el"></div>
    </div>
    <!-- type=6 等场景：整块侧栏（含结果）不展示 -->
    <template v-if="!hideSearchFilters">
    <!-- 展开/收缩按钮 -->
    <div
      class="toggle-btn"
      :class="{ collapsed: isCollapsed }"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="toggleSidebar"
      @keyup.enter.prevent="toggleSidebar"
      @keyup.space.prevent="toggleSidebar"
    >
      <i :class="isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>
    <div class="main-content" :class="{ 'collapsed': isCollapsed }">
      <!-- 左侧查询区域 -->
      <div class="left-panel" v-show="!isCollapsed" style="padding: 0.9375rem;">
        <div class="single-filter-section">
        <el-form :model="searchForm" :rules="rules" ref="searchForm" label-position="top">
          <div class="form-row">
            <el-form-item label="车牌号" class="form-item" prop="licensePlate">
              <PlateLicenseField
                v-model="searchForm.licensePlate"
                placeholder="输入车牌号"
                :disabled="isFilterDisabled"
                :enable-tree-fetch="garageTreeFetchEnabled"
                :garage-tree-list-url="garageTreeListUrl"
                :garage-tree-list-use-request="garageTreeListUseRequest"
                :garage-tree-children-url="garageTreeChildrenUrl"
                :garage-tree-children-use-request="garageTreeChildrenUseRequest"
                @vehicle-select="onVehiclePlateFromListSelected"
              />
            </el-form-item>
            <el-form-item label="车牌号颜色" class="form-item" prop="licensePlateColor">
              <el-select v-model="searchForm.licensePlateColor" placeholder="请选择" :disabled="isFilterDisabled">
                <el-option v-for="color in plateColorOptions" :key="color.value" :label="color.label" :value="color.value" />
              </el-select>
            </el-form-item>
          </div>

          <el-form-item label="出发时间" class="form-item" prop="startTime">
            <el-date-picker style="height:2.5rem;width: 100%" v-model="value1" type="datetimerange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
              :picker-options="searchDatePickerOptions"
              @change="handleDateChange" :disabled="isFilterDisabled">
            </el-date-picker>
            <div v-if="timeRangePresets && !isFilterDisabled" class="leftjoin-time-presets">
              <el-button size="small" @click="applyTimeRangePreset(0)">今天</el-button>
              <el-button size="small" @click="applyTimeRangePreset(1)">近两天</el-button>
              <el-button size="small" @click="applyTimeRangePreset(2)">近三天</el-button>
            </div>
          </el-form-item>

          <div class="single-filter-extra-fields">
            <div v-if="!hideOriginDestinationFilters" class="form-row">
              <el-form-item label="始发地" class="form-item">
                <el-cascader style="width: 100%" size="large" :options="options" v-model="selectedOptionsFrist"
                  @change="handleChangeFrist" clearable :disabled="isFilterDisabled">
                </el-cascader>
              </el-form-item>
              <el-form-item label="目的地" class="form-item">
                <el-cascader style="width: 100%" size="large" :options="options" v-model="selectedOptionsLast"
                  @change="handleChangeLast" clearable :disabled="isFilterDisabled">
                </el-cascader>
              </el-form-item>
            </div>
            <div v-if="!hideOriginDestinationFilters" class="form-row">
              <el-form-item label="始发地坐标" class="form-item">
                <el-input clearable v-model="searchForm.originCoord" placeholder="请选择坐标" :disabled="isFilterDisabled">
                  <el-button slot="append" icon="el-icon-location" @click="openMapDialog('origin')" :disabled="isFilterDisabled"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="目的地坐标" class="form-item">
                <el-input clearable v-model="searchForm.destCoord" placeholder="请选择坐标" :disabled="isFilterDisabled">
                  <el-button slot="append" icon="el-icon-location" @click="openMapDialog('dest')" :disabled="isFilterDisabled"></el-button>
                </el-input>
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item label="上游停车筛选(分钟)" class="form-item" >
                <div style="display: flex; align-items: center;">
                  <el-input clearable style="margin-right: 1rem;" v-model="searchForm.parkMins" placeholder="可清空，不填写则不追加筛选" :disabled="isFilterDisabled"></el-input>
<!--                <el-checkbox v-model="searchForm.includeParking" :disabled="isFilterDisabled">停车点</el-checkbox>-->
<!--              <el-checkbox v-model="searchForm.includeMileage" :disabled="isFilterDisabled">里程</el-checkbox>-->
                </div>
              </el-form-item>
            </div>

            <el-form-item v-if="!isFilterDisabled && !hideSearchButton" class="single-filter-search-item">
              <el-button type="primary" @click="handleSearch" class="search-btn">查询</el-button>
            </el-form-item>
          </div>

        </el-form>
        </div>
        <slot name="independent-controls" />
        <template v-if="showGaragePanel">
          <el-tabs v-model="activeGarageLayoutTab" class="leftjoin-garage-tabs">
            <el-tab-pane label="结果" name="result">
              <div class="result-panel result-panel--in-tab">
                <div class="result-title">结果</div>
                <div v-if="routeData&&type==3" class="result-content">
                  <div v-if="!hideResultEstimateArriveTime" class="result-item">预计到达时间: {{ formatEstimateArriveTime(routeData.estimateArriveTime)||'-' }}</div>
                  <div class="result-item">路程总里程: {{ formatResultMileage(routeData.mileage) }}</div>
                  <div class="result-item">停车次数: {{ routeData.parkSize?routeData.parkSize+'次': '-' }}</div>
                  <div class="result-item">最后位置: {{ lastTrackAddressDisplay }}</div>
                  <div class="result-item">最后定位时间: {{ lastTrackTimeDisplay }}</div>
                </div>
                <div v-else class="result-content">
                  <div class="result-item">请点击查询按钮获取数据</div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
        <div v-else class="result-panel">
          <div class="result-title">结果</div>
          <div v-if="routeData&&type==3" class="result-content">
            <div v-if="!hideResultEstimateArriveTime" class="result-item">预计到达时间: {{ formatEstimateArriveTime(routeData.estimateArriveTime)||'-' }}</div>
            <!-- <div class="result-item">剩余途距: {{ routeData.remainDistance?routeData.remainDistance+'km': '-' }}</div> -->
            <div class="result-item">路程总里程: {{ formatResultMileage(routeData.mileage) }}</div>
            <div class="result-item">停车次数: {{ routeData.parkSize?routeData.parkSize+'次': '-' }}</div>
            <div class="result-item">最后位置: {{ lastTrackAddressDisplay }}</div>
            <div class="result-item">最后定位时间: {{ lastTrackTimeDisplay }}</div>
            <!-- <div class="result-item">离线状态: {{ routeData.offlineState ? '离线' : '在线' }}</div> -->
          </div>
          <div v-else class="result-content">
            <div class="result-item">请点击查询按钮获取数据</div>
          </div>
        </div>
      </div>
    </div>
    </template>

    <!-- 地图弹窗 -->
    <el-dialog title="地图信息" :visible.sync="mapDialogVisible" width="70%" height="50%" @close="onPickerMapDialogClose">
      <div class="map-dialog-content">
        <div class="map-search">
          <el-autocomplete v-model="mapSearchText" :fetch-suggestions="querySearchAsync" placeholder="请输入位置"
            style="width: 18.75rem;" @select="handleSelect" @keyup.enter="searchLocation" popper-append-to-body
            trigger-on-focus :highlight-first-item="true">
            <el-button slot="append" icon="el-icon-search" @click="searchLocation"></el-button>
          </el-autocomplete>
        </div>
        <div ref="mapDialogSlot" class="map-container"></div>
      </div>
      <div style="width: 100%;display: flex;justify-content: flex-end;">
        <el-button style="width: 4.375rem"  type="primary" @click="mapDialogVisible = false" class="search-btn">确定</el-button>
      </div>

    </el-dialog>
    <template v-if="infoShow && billInfo">
       <div
      class="toggle-btn"
      :class="{ collapsed: isCollapsed }"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="toggleSidebar"
      @keyup.enter.prevent="toggleSidebar"
      @keyup.space.prevent="toggleSidebar"
    >
      <i :class="isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>
    <div  class="main-content" :class="{ 'collapsed': isCollapsed }">
      <div class="left-panel" v-show="!isCollapsed" style="padding: 0;">
        <div  class="leftjoin-bill-card__header">
          <span class="leftjoin-bill-card__plate">{{ billInfo.gentlyBillVehicle&&billInfo.gentlyBillVehicle.vehicleNo?billInfo.gentlyBillVehicle.vehicleNo:'' }}</span>
        </div>
        <div class="leftjoin-bill-card__body">
          <div class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">运单号：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.consigNo||'' }}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">货物名称：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.gentlyBillGoods&&billInfo.gentlyBillGoods.goodsName?billInfo.gentlyBillGoods.goodsName:'' }}{{ billInfo.gentlyBillGoods&&billInfo.gentlyBillGoods.weight?billInfo.gentlyBillGoods.weight:'' }}{{ billInfo.gentlyBillGoods&&billInfo.gentlyBillGoods.unit?billInfo.gentlyBillGoods.unit:'' }}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">装货单位：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.sendCompany||''}}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">装货地址：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.sendProvince||'' }}{{ billInfo.sendCity||'' }}{{ billInfo.sendDistrict||'' }}{{ billInfo.sendAddress||'' }}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">卸货单位：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.recvCompany||'' }}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">卸货地址：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.recvProvince||'' }}{{ billInfo.recvCity||'' }}{{ billInfo.recvDistrict||'' }}{{ billInfo.recvAddress||'' }}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">预计到场时间：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.expectPresentTime||'' }}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">预计提货时间：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.expectPickTime||'' }}</span>
          </div>
          <div  class="leftjoin-bill-card__row">
            <span class="leftjoin-bill-card__label">预计送达时间：</span>
            <span class="leftjoin-bill-card__value">{{ billInfo.expectArriveTime||'' }}</span>
          </div>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import { regionData } from "element-china-area-data";
import request from '@/utils/request'
import { setAmapSecurityConfig, loadAmapSDK } from "@/utils/amapConfig";
import { tiandituReverseGeocode } from '@/utils/tiandituGeocoder';
import coordtransform from '@/WGS84.js';
import { setScopedLicensePlate, setScopedPlateColor } from '@/utils/scopedLocalStorage'
import { resolveAddressByCoord as resolveAddressByCoordUtil, isValidResolvedAddress, normalizeCoordKey } from '@/utils/coordAddressResolver'
import PlateLicenseField from '@/components/PlateLicenseField.vue'
import { getSearchEndpointPairError } from '@/utils/searchEndpointWarning'
import vehicleDataAutocompleteMixin from '@/mixins/vehicleDataAutocomplete'
import nativePlateColorsMixin from '@/mixins/nativePlateColors'
import {
  getSearchEarliestAllowedDate,
  isLicensePlateFormatValid,
  validateSearchTimeRange
} from '@/utils/searchFilterValidate';
/* global AMap */
export default {
  name: 'LeftJoin',
  mixins: [vehicleDataAutocompleteMixin, nativePlateColorsMixin],
  components: {
    PlateLicenseField
  },
  props: {
    /** 仅特定页面开启：时间范围快捷按钮（今天/近两天/近三天） */
    timeRangePresets: {
      type: Boolean,
      default: false
    },
    isFilterDisabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 3
    },
    /** 历史轨迹等场景：禁止选择「今天」之后的日期，且时刻不得超过当前（其他页面勿传，保持默认 false） */
    restrictDateTimeToPast: {
      type: Boolean,
      default: false
    },
    /** 为 true 时左侧「结果」不展示预计到达时间（由父页自行展示）；默认 false */
    hideResultEstimateArriveTime: {
      type: Boolean,
      default: false
    },
    /**
     * 与 restrictDateTimeToPast 配合：结束时间晚于「当前时刻」时自动改为当前时刻，不再报错。
     * 历史轨迹旧页开启；其他页默认 false，保持原「请重新选择」提示。
     */
    clampEndTimeToNow: {
      type: Boolean,
      default: false
    },
    /** 历史轨迹插件 type=6：不展示整块左侧（筛选+结果+展开条，其他页面勿传） */
    hideSearchFilters: {
      type: Boolean,
      default: false
    },
    /**
     * 某些分享场景由父组件自动查询，隐藏「查询」按钮。
     * 为 true 时：出发时间仅作回显，不做区间/180 天/未来时刻等校验，日期选择器不禁用任意日。
     */
    hideSearchButton: {
      type: Boolean,
      default: false
    },
    /** 历史轨迹页：车牌号改为远程下拉选择（由父页根据输入 contacts 模糊查询） */
    vehicleNoRemoteSelect: {
      type: Boolean,
      default: false
    },
    /** (contacts: string) => Promise<Array<{label: string, value: string}>> */
    vehicleNoFetchOptions: {
      type: Function,
      default: null
    },
    /**
     * 外部强制控制：当该值为 true 时，把左侧默认折叠（isCollapsed=true），并通知父组件 @toggle=true。
     * 主要用于 historicalTrajectoryNew 的 showType=export 场景。
     */
    forceCollapsed: {
      type: Boolean,
      default: false
    },
    /** 历史轨迹新页可传 true：隐藏始发地/目的地及其坐标筛选 */
    hideOriginDestinationFilters: {
      type: Boolean,
      default: false
    },
    /** 父页按需开启：默认时间为当天 0 点到当前时间 */
    defaultTodayTimeRange: {
      type: Boolean,
      default: false
    },
    /**
     * 仅 historicalTrajectoryNew 传 true：展示「车库 / 结果」标签与车库；车库单选车辆后回显车牌与颜色。
     */
    showGaragePanel: {
      type: Boolean,
      default: false
    },
    /** 车库树首层：非空且 garageTreeListUseRequest 时用 request.get（如 本地正常车辆候选） */
    garageTreeListUrl: {
      type: String,
      default: ''
    },
    garageTreeListUseRequest: {
      type: Boolean,
      default: false
    },
    /** 车库懒加载子节点：非空且 garageTreeChildrenUseRequest 时用 request.get */
    garageTreeChildrenUrl: {
      type: String,
      default: ''
    },
    garageTreeChildrenUseRequest: {
      type: Boolean,
      default: false
    },
    /**
     * 为 true 时：车库面板内分组/车辆增删走 request + 本地只读候选（与 garageTreeListUseRequest 独立）。
     */
    garageWebCrudUseRequest: {
      type: Boolean,
      default: false
    },
    /**
     * 与 historicalTrajectory.getParams 一致：URL 带插件 token `p` 时由父页传入 true。
     * 此时不展示「途径城市」tab，结果区也不展示发货/交货（或始发/目的地）是否经过。
     */
    trajectoryPluginEmbed: {
      type: Boolean,
      default: false
    },
    /** 起终点展示覆盖（仅改文案） */
    trajectoryDisplayOverride: {
      type: Object,
      default: null
    },
    // 危化信息展示/
    infoShow: {
      type: Boolean,
      default: false
    },
    billInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // 左侧面板展开/收缩状态
      isCollapsed: false,
      // 查询表单
      searchForm: {
        licensePlate: '', // 车牌号
        licensePlateColor: '2', // 车牌号颜色(1蓝色、2黄色、3绿色)
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        origin: '', // 始发地
        destination: '', // 目的地
        originCoord: '', // 始发地坐标
        destCoord: '', // 目的地坐标
        originAddress: '', // 地图选中的始发地名称/地址
        destAddress: '', // 地图选中的目的地名称/地址
        startAreaCode: '', // 始发地行政区划编码
        endAreaCode: '', // 目的地行政区划编码
        parkMins: 10, // 停车时长
        includeParking: false,
        includeMileage: false
      },
      options: regionData, //城市选择
      selectedOptionsFrist: [], //始发地
      selectedOptionsLast: [],//目的地
      value1: [], // 日期范围，初始为空
      // 地图相关
      mapDialogVisible: false,
      mapSearchText: '',
      currentCoordType: '', // 'origin' 或 'dest'
      map: null,
      // 搜索建议
      searchResults: [],
      autoComplete: null, // 添加 autoComplete 实例
      // 接口返回数据
      routeData: null,
      /** 轨迹最后一点无 adr 时，逆地理编码得到的地址（与轨迹明细一致） */
      lastResolvedTrackAddress: '',
      /** 选点地图单例初始化 Promise，防并发重复创建 */
      pickerMapInitPromise: null,
      // 远程下拉车牌（仅在 vehicleNoRemoteSelect 打开时生效）
      vehicleNoRemoteOptions: [],
      vehicleNoRemoteLoading: false,
      vehicleNoRemoteQueryToken: 0,
      activeGarageLayoutTab: 'result'
    }
  },
  computed: {
    /** 需用 computed，校验器内才可访问 this.searchForm */
    rules() {
      const vm = this
      const base = {
        licensePlate: [
          { required: true, message: '请输入车牌号', trigger: ['blur', 'change'] },
          {
            validator(rule, value, callback) {
              const plate = value != null ? String(value).trim() : ''
              if (!plate) {
                callback(new Error('请输入车牌号'))
                return
              }
              if (!isLicensePlateFormatValid(plate)) {
                callback(new Error('请输入正确格式的车牌号'))
                return
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        licensePlateColor: [
          { required: true, message: '请选择车牌号颜色', trigger: 'change' }
        ]
      }
      if (vm.hideSearchButton) {
        return base
      }
      return {
        ...base,
        startTime: [
          { required: true, message: '请选择出发时间', trigger: 'change' },
          {
            validator(rule, value, callback) {
              const r = validateSearchTimeRange(vm.searchForm.startTime, vm.searchForm.endTime)
              if (!r.valid) {
                callback(new Error(r.message))
                return
              }
              if (vm.restrictDateTimeToPast) {
                if (vm.clampEndTimeToNow) {
                  vm.applyClampEndTimeToNow()
                }
                const now = new Date()
                const nowMs = now.getTime()
                const startMs = new Date(vm.searchForm.startTime).getTime()
                const endMs = new Date(vm.searchForm.endTime).getTime()
                if (!vm.clampEndTimeToNow && endMs > nowMs) {
                  callback(new Error('结束时间不能超过当前时间，请重新选择'))
                  return
                }
                if (startMs > nowMs) {
                  callback(new Error('开始时间不能超过当前时间，请重新选择'))
                  return
                }
              }
              callback()
            },
            trigger: 'change'
          }
        ],
        endTime: [{ required: true, message: '请选择出发时间', trigger: 'change' }]
      }
    },
    searchDatePickerOptions() {
      if (this.hideSearchButton) {
        return {}
      }
      const vm = this
      return {
        disabledDate(time) {
          const earliest = getSearchEarliestAllowedDate()
          const dayStart = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
          const cell = dayStart(time)
          if (cell < dayStart(earliest)) return true
          if (vm.restrictDateTimeToPast) {
            return cell > dayStart(new Date())
          }
          return false
        }
      }
    },
    /** runRoute 最后一条轨迹点 */
    lastRunRoutePoint() {
      const r = this.routeData && this.routeData.runRoute
      if (!r || !r.length) return null
      return r[r.length - 1]
    },
    /** 最后一条轨迹点对应时间（gtm） */
    lastTrackTimeDisplay() {
      const p = this.lastRunRoutePoint
      if (!p || !p.gtm) return '-'
      return this.formatTrackGtm(p.gtm)
    },
    /** 最后一条轨迹点地址：点字段优先，其次逆地理，再退回接口顶层 adr（纯经纬度串不作为地址） */
    lastTrackAddressDisplay() {
      const valid = (s) => {
        if (s == null) return ''
        const t = String(s).trim()
        return isValidResolvedAddress(t) ? t : ''
      }
      const ov = this.trajectoryDisplayOverride && this.trajectoryDisplayOverride.end
      const ovLoc = ov && ov.location != null ? valid(ov.location) : ''
      if (ovLoc) return ovLoc
      const p = this.lastRunRoutePoint
      if (!p) return '-'
      if (valid(this.lastResolvedTrackAddress)) return String(this.lastResolvedTrackAddress).trim()
      const adr = valid(p.adr)
      if (adr) return adr
      const loc = valid(p.location)
      if (loc) return loc
      if (p.lon != null && p.lat != null) return '获取位置中...'
      if (this.routeData && this.routeData.adr) {
        const top = valid(this.routeData.adr)
        if (top) return top
      }
      return '-'
    },
    /** 远程下拉车牌：保证已选值在 options 中，避免回显丢失 */
    vehicleNoRemoteOptionsWithSelected() {
      const v = this.searchForm && this.searchForm.licensePlate
      const list = Array.isArray(this.vehicleNoRemoteOptions) ? this.vehicleNoRemoteOptions : []
      if (v && !list.some((o) => o && String(o.value) === String(v))) {
        return [{ label: String(v), value: String(v) }, ...list]
      }
      return list
    },
    /** 多车轨迹嵌入预览/只读页：不请求 truck/team/tree/first */
    garageTreeFetchEnabled() {
      return this.showGaragePanel && !this.hideSearchButton
    },
  },
  watch: {
    forceCollapsed: {
      immediate: true,
      handler(val) {
        if (val) {
          this.isCollapsed = true
          this.$emit('toggle', true)
        }
      }
    },
    hideSearchFilters: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$emit('toggle', true)
        }
      }
    },
    hideSearchButton: {
      immediate: true,
      handler(val) {
        if (this.showGaragePanel) {
          this.activeGarageLayoutTab = 'result'
        }
        if (!val) return
        this.$nextTick(() => {
          const form = this.$refs.searchForm
          if (form && typeof form.clearValidate === 'function') {
            form.clearValidate(['startTime', 'endTime'])
          }
        })
      }
    },
    routeData: {
      handler(val) {
        this.lastResolvedTrackAddress = ''
        this.refreshLastTrackAddress()
        if (this.showGaragePanel && val) {
          this.activeGarageLayoutTab = 'result'
        }
      },
      deep: true
    },
    'searchForm.originCoord'() {
      if (!this.map || this.mapDialogVisible) return
      const c = this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      if (!c) return
      this.$nextTick(() => {
        try {
          if (this.map && !this.mapDialogVisible) this.map.setCenter(c)
        } catch (e) {
          console.warn('选点地图同步中心失败', e)
        }
      })
    }
  },
  mounted() {
    if (this.defaultTodayTimeRange) {
      this.applyDefaultTodayTimeRange()
    }
    if (!this.hideSearchFilters) {
      this.$nextTick(() => {
        this.ensurePickerMapLoaded().catch((e) => {
          console.warn('选点地图预加载失败，打开弹窗时将重试', e)
        })
      })
    }
  },
  beforeDestroy() {
    if (this.map) {
      try {
        this.map.destroy()
      } catch (e) {
        /* ignore */
      }
      this.map = null
    }
    this.pickerMapInitPromise = null
  },
  methods: {
    onPlateColorAccountChanged() { this.searchForm.licensePlate = ''; this.searchForm.licensePlateColor = '2'; this.routeData = null },
    formatResultMileage(value) {
      if ((typeof value !== 'number' && typeof value !== 'string') || String(value).trim() === '') return '-'
      const mileage = Number(value)
      return Number.isFinite(mileage) ? `${mileage.toFixed(2)}km` : '-'
    },
    applyDefaultTodayTimeRange() {
      if (this.searchForm.startTime || this.searchForm.endTime) return
      const now = new Date()
      const startOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0
      )
      this.value1 = [startOfDay, now]
      this.searchForm.startTime = this.formatDateTime(startOfDay)
      this.searchForm.endTime = this.formatDateTime(now)
    },
    /**
     * 快捷时间（相对「结束时间」所在日）：
     * 0=当天0点～结束时间；1=前1天0点～结束时间（近两天）；2=前2天0点～结束时间（近三天）
     */
    applyTimeRangePreset(daysBack) {
      const n = Number(daysBack)
      const back = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
      const endRaw = this.searchForm && this.searchForm.endTime ? String(this.searchForm.endTime).trim() : ''
      let end = endRaw ? new Date(endRaw.replace(/-/g, '/')) : null
      if (!end || Number.isNaN(end.getTime())) end = new Date()
      const endMs = end.getTime()
      const endDayStart = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0, 0)
      endDayStart.setDate(endDayStart.getDate() - back)
      const start = endDayStart
      const value = [start, new Date(endMs)]
      this.value1 = value
      this.handleDateChange(value)
    },
    /** 轨迹点 gtm：yyyymmdd/hhmmss → yyyy-MM-dd hh:mm:ss */
    formatTrackGtm(gtm) {
      if (!gtm || String(gtm).length < 15) return '-'
      try {
        const datePart = gtm.substring(0, 8)
        const timePart = gtm.substring(9)
        if (!datePart || !timePart || timePart.length < 6) return '-'
        const year = datePart.substring(0, 4)
        const month = datePart.substring(4, 6)
        const day = datePart.substring(6, 8)
        const hour = timePart.substring(0, 2)
        const minute = timePart.substring(2, 4)
        const second = timePart.substring(4, 6)
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`
      } catch (e) {
        return '-'
      }
    },
    /** 对轨迹最后一点做统一地址解析（与右侧结束位置同链路） */
    async refreshLastTrackAddress() {
      const data = this.routeData
      if (!data || !data.runRoute || !data.runRoute.length) return
      const p = data.runRoute[data.runRoute.length - 1]
      if (!p) return
      if (p.lon == null || p.lat == null) return
      try {
        const normalized = this.normalizeRunRouteLonLat(p.lon, p.lat)
        if (!normalized) return
        const [lng, lat] = normalized
        const coordKey = normalizeCoordKey(lng, lat)
        const address = await this.resolveAddressByCoord(lng, lat, coordKey)
        if (isValidResolvedAddress(address)) this.lastResolvedTrackAddress = String(address).trim()
      } catch (e) {
        console.warn('最后轨迹点逆地理失败', e)
      }
    },
    normalizeRunRouteLonLat(lon, lat) {
      const nlon = Number(lon)
      const nlat = Number(lat)
      if (!Number.isFinite(nlon) || !Number.isFinite(nlat)) return null
      const isScaled = Math.max(Math.abs(nlon), Math.abs(nlat)) > 10000
      if (isScaled) {
        const lonWgs84 = nlon / 600000.0
        const latWgs84 = nlat / 600000.0
        return coordtransform.wgs84togcj02(lonWgs84, latWgs84)
      }
      return [nlon, nlat]
    },
    /**
     * 统一地址解析（缓存 -> 高德逆地理 -> stopaddress兜底）。
     * 说明：LeftJoin 侧只需要最终地址字符串（无需本地缓存响应式）。
     */
    async resolveAddressByCoord(lon, lat, coordKey) {
      return await resolveAddressByCoordUtil(lon, lat, {
        coordKey: coordKey || normalizeCoordKey(lon, lat),
        axiosInstance: request,
        AMap: typeof window !== 'undefined' ? window.AMap : null
      })
    },
    // 始发地
    handleChangeFrist() {
      if (this.selectedOptionsFrist && this.selectedOptionsFrist.length > 0) {
        for (let i = 0; i < this.selectedOptionsFrist.length; i++) {
          this.searchForm.origin =this.selectedOptionsFrist[2]}
      } else {
        this.searchForm.origin = '';
      }
    },
    // 目的地
    handleChangeLast() {
      if (this.selectedOptionsLast && this.selectedOptionsLast.length > 0) {
        for (let i = 0; i < this.selectedOptionsLast.length; i++) {
          this.searchForm.destination =this.selectedOptionsLast[2];
        }
      } else {
        this.searchForm.destination = '';
      }
    },
    // 处理日期选择
    handleDateChange(value) {
      if (value && value.length === 2) {
        let endDate = value[1]
        if (
          !this.hideSearchButton &&
          this.restrictDateTimeToPast &&
          this.clampEndTimeToNow &&
          endDate &&
          endDate.getTime() > Date.now()
        ) {
          endDate = new Date()
          this.value1 = [value[0], endDate]
        }
        this.searchForm.startTime = this.formatDateTime(value[0])
        this.searchForm.endTime = this.formatDateTime(endDate)
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
      this.$nextTick(() => {
        const form = this.$refs.searchForm
        if (!form) return
        if (this.hideSearchButton) {
          if (typeof form.clearValidate === 'function') {
            form.clearValidate(['startTime', 'endTime'])
          }
          return
        }
        form.validateField('startTime')
        form.validateField('endTime')
      })
    },
    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    /** 远程车牌请求父级方法，并把结果缓存到 vehicleNoRemoteOptions */
    async fetchVehicleNoRemoteOptions(contacts) {
      if (this.vehicleDataAutocomplete) {
        return this.fetchVehicleNoFromDataList(contacts)
      }
      if (!this.vehicleNoFetchOptions) return []
      const token = ++this.vehicleNoRemoteQueryToken
      this.vehicleNoRemoteLoading = true
      try {
        const list = await this.vehicleNoFetchOptions(contacts)
        if (token !== this.vehicleNoRemoteQueryToken) return []
        this.vehicleNoRemoteOptions = Array.isArray(list) ? list : []
        return this.vehicleNoRemoteOptions
      } catch (e) {
        console.error('vehicleNoFetchOptions error', e)
        if (token !== this.vehicleNoRemoteQueryToken) return []
        this.vehicleNoRemoteOptions = []
        return []
      } finally {
        if (token === this.vehicleNoRemoteQueryToken) {
          this.vehicleNoRemoteLoading = false
        }
      }
    },
    // 切换左侧面板展开/收缩
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
      // 通知父组件状态变化
      this.$emit('toggle', this.isCollapsed)
    },
    // 截图导出前由父组件强制收起左侧
    forceCollapseForCapture() {
      this.isCollapsed = true
      this.$emit('toggle', true)
    },
    isNarrowScreenForSearch() {
      if (typeof window === 'undefined') return false
      return window.innerWidth < 750
    },
    isMobileClient() {
      if (typeof navigator === 'undefined') return false
      const ua = navigator.userAgent || ''
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
    },
    shouldAutoCollapseLeftAfterSearch() {
      return this.isNarrowScreenForSearch() || this.isMobileClient()
    },
    /** 结束时间晚于当前时刻时截断为当前时刻（与 clampEndTimeToNow 配合） */
    applyClampEndTimeToNow() {
      if (!this.restrictDateTimeToPast || !this.clampEndTimeToNow) return
      if (!this.searchForm.endTime) return
      const now = new Date()
      const nowMs = now.getTime()
      const endMs = new Date(this.searchForm.endTime).getTime()
      if (!Number.isFinite(endMs) || endMs <= nowMs) return
      this.searchForm.endTime = this.formatDateTime(now)
      if (this.value1 && Array.isArray(this.value1) && this.value1.length === 2) {
        this.value1 = [this.value1[0], new Date(nowMs)]
      }
    },
    // 处理查询
    handleSearch() {
      if (!this.requirePlateColor(this.searchForm.licensePlateColor)) return
      if (!this.hideSearchButton) {
        this.applyClampEndTimeToNow()
      }
      // 全量校验（隐藏查询按钮时不校验时间，见 rules）
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          const endpointError = getSearchEndpointPairError({ startAreaCode: this.searchForm.origin, endAreaCode: this.searchForm.destination, startLonlat: this.searchForm.originCoord, endLonlat: this.searchForm.destCoord })
          if (endpointError) return this.$message.warning(endpointError)
          // 存储车牌号到本地存储
          if (this.searchForm.licensePlate) {
            const scope = this.$route && this.$route.path ? this.$route.path : undefined
            setScopedLicensePlate(this.searchForm.licensePlate, scope)
          }
          // 构建查询参数，映射为图片中的参数名
          const params = {
            vclN: this.searchForm.licensePlate, // 车牌号
            vco: this.searchForm.licensePlateColor, // 车牌号颜色
            qryBtm: this.searchForm.startTime, // 开始时间
            qryEtm: this.searchForm.endTime, // 结束时间
            startLonlat: this.searchForm.originCoord, // 始发地坐标
            endLonlat: this.searchForm.destCoord, // 目的地坐标
            startAreaCode: this.searchForm.origin, // 始发地行政区划编码
            endAreaCode: this.searchForm.destination,// 目的地行政区划编码
            startAddress: this.searchForm.originAddress,
            endAddress: this.searchForm.destAddress,
            parkMins: this.searchForm.parkMins // 停车时长
          }
          // 这里可以添加查询逻辑
          this.$emit('search', params)
          if (this.shouldAutoCollapseLeftAfterSearch() && !this.isCollapsed) {
            this.isCollapsed = true
            this.$emit('toggle', true)
          }
        } else {
          return false;
        }
      });
    },
    /** 解析「lng,lat」或「lng lat」坐标串，失败返回 null */
    parseLngLatFromCoordStr(str) {
      if (str == null || String(str).trim() === '') return null
      const s = String(str).trim().replace(/\s+/g, ',')
      const parts = s.split(',').map((x) => parseFloat(x.trim())).filter((n) => Number.isFinite(n))
      if (parts.length < 2) return null
      const [lng, lat] = parts
      if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return null
      return [lng, lat]
    },
    /** 预加载/选点地图中心：优先始发地坐标 */
    getPickerMapCenterFromForm() {
      return this.parseLngLatFromCoordStr(this.searchForm.originCoord) || [116.404, 39.915]
    },
    applyMapCenterForPickType(type) {
      if (!this.map) return
      let c = null
      if (type === 'dest') {
        c = this.parseLngLatFromCoordStr(this.searchForm.destCoord) ||
          this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      } else {
        c = this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      }
      const center = c || [116.404, 39.915]
      try {
        this.map.setZoomAndCenter(15, center, true)
      } catch (e) {
        console.warn('选点地图设置中心失败', e)
      }
    },
    /** 与 applyMapCenterForPickType 一致：当前选点类型下用于展示标记的坐标；无则 null */
    getCoordLngLatForPickerType(type) {
      if (type === 'dest') {
        const d = this.parseLngLatFromCoordStr(this.searchForm.destCoord)
        if (d) return d
        return this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      }
      return this.parseLngLatFromCoordStr(this.searchForm.originCoord)
    },
    /** 打开选点弹窗时：清除上次覆盖物，再按表单重置中心与标记（输入框清空后不再残留旧选点） */
    syncPickerMapWithFormCoords(type) {
      if (!this.map) return
      try {
        this.map.clearMap()
      } catch (e) {
        console.warn('选点地图 clearMap 失败', e)
      }
      this.applyMapCenterForPickType(type)
      const pos = this.getCoordLngLatForPickerType(type)
      if (pos && window.AMap) {
        try {
          new AMap.Marker({
            position: pos,
            map: this.map
          })
        } catch (e) {
          console.warn('选点地图标记失败', e)
        }
      }
    },
    attachPickerMapToDialog() {
      const slot = this.$refs.mapDialogSlot
      const el = this.$refs.mapSingletonEl
      if (!slot || !el) return
      if (el.parentNode !== slot) slot.appendChild(el)
    },
    onPickerMapDialogClose() {
      const wrap = this.$refs.mapPrewarmWrap
      const el = this.$refs.mapSingletonEl
      if (this.map && wrap && el && el.parentNode !== wrap) {
        wrap.appendChild(el)
        this.$nextTick(() => {
          try {
            if (this.map) this.map.resize()
          } catch (e) {
            console.warn('选点地图 resize 失败', e)
          }
        })
      }
    },
    async ensurePickerMapLoaded() {
      if (this.map) return
      if (!this.pickerMapInitPromise) {
        this.pickerMapInitPromise = this.createPickerMapOnce().catch((err) => {
          this.pickerMapInitPromise = null
          throw err
        })
      }
      await this.pickerMapInitPromise
    },
    async createPickerMapOnce() {
      await this.$nextTick()
      let retries = 10
      while (!this.$refs.mapSingletonEl && retries-- > 0) {
        await new Promise((r) => setTimeout(r, 50))
      }
      const container = this.$refs.mapSingletonEl
      if (!container) throw new Error('地图容器未就绪')

      setAmapSecurityConfig()
      await loadAmapSDK([
        'AMap.Geocoder',
        'AMap.PlaceSearch',
        'AMap.MouseTool',
        'AMap.CircleEditor',
        'AMap.PolygonEditor',
        'AMap.MarkerCluster',
        'AMap.GeometryUtil',
        'AMap.Scale',
        'AMap.ToolBar',
        'AMap.AutoComplete'
      ])

      const center = this.getPickerMapCenterFromForm()
      this.map = new AMap.Map(container, {
        zoom: 11,
        center,
        resizeEnable: true,
        mapStyle: 'amap://styles/6e581a480732b7393cf1f6f02c9c4c5a',
        zooms: [3, 16],
        features: ['point', 'road', 'building', 'boundary']
      })
      this.map.addControl(new AMap.ToolBar())
      this.map.on('click', (e) => {
        const lng = e.lnglat.getLng()
        const lat = e.lnglat.getLat()
        this.getAddress(lng, lat)
      })
      this.initAutoComplete()
    },
    // 打开地图弹窗（复用单例地图，仅移动 DOM + resize）
    openMapDialog(type) {
      this.currentCoordType = type
      this.mapDialogVisible = true
      this.$nextTick(async () => {
        try {
          await this.ensurePickerMapLoaded()
          this.attachPickerMapToDialog()
          await this.$nextTick()
          try {
            if (this.map) this.map.resize()
          } catch (e) {
            console.warn('选点地图 resize 失败', e)
          }
          this.syncPickerMapWithFormCoords(type)
        } catch (error) {
          console.error('地图加载失败:', error)
          this.$message.error('地图加载失败，请刷新重试')
        }
      })
    },
    // 初始化 AutoComplete
    initAutoComplete() {
      if (window.AMap) {
        AMap.plugin('AMap.AutoComplete', () => {
          this.autoComplete = new AMap.AutoComplete({
            city: '全国',
            citylimit: false
            // ⚠️ 注意：这里千万不要传 securityJsCode
          });
        });
      }
    },
    // 模糊查询（修改后的版本）
    querySearchAsync(queryString, callback) {
      if (!queryString) {
        callback([]);
        return;
      }

      // 确保 AMap 已加载
      if (!window.AMap) {
        callback([]);
        return;
      }

      // 使用 AMap.plugin 加载 AutoComplete 插件
      AMap.plugin('AMap.AutoComplete', () => {
        this.performSearch(queryString, callback);
      });
    },
    // 执行搜索
    performSearch(queryString, callback) {
      if (!window.AMap) {
        callback([]);
        return;
      }

      // 每次查询都创建新的实例
      const auto = new AMap.AutoComplete({
        city: '全国',
        citylimit: false
        // ⚠️ 注意：这里千万不要传 securityJsCode
      });

      auto.search(queryString, (status, result) => {
        console.log('AutoComplete 搜索状态:', status, queryString);
        console.log('AutoComplete 搜索结果:', result);

        if (status === 'complete' && result.info === 'OK' && result.tips) {
          const suggestions = result.tips
            .filter(tip => tip.location)
            .map(tip => ({
              value: tip.name,
              address: tip.district + (tip.address || ''),
              location: tip.location,
              _raw: tip
            }))
            .slice(0, 10);

          console.log('搜索建议:', suggestions);
          callback(suggestions);
        } else {
          console.log('搜索失败:', status, result);
          callback([]);
        }
      });
    },

    // 处理选择搜索建议（修改以支持新格式）
    handleSelect(item) {
      this.mapSearchText = item.value;

      // 如果有位置信息
      if (item.location) {
        // 处理 location 可能是字符串 "lng,lat" 或对象的情况
        let lng, lat;

        if (typeof item.location === 'string') {
          const coords = item.location.split(',');
          lng = parseFloat(coords[0]);
          lat = parseFloat(coords[1]);
        } else if (item.location.lng && item.location.lat) {
          lng = item.location.lng;
          lat = item.location.lat;
        }

        if (lng && lat) {
          // 移动地图到选择的位置
          this.map.setZoomAndCenter(15, [lng, lat], true);

          const coord = `${lng},${lat}`;
          if (this.currentCoordType === 'origin') {
            this.searchForm.originCoord = coord;
            this.searchForm.originAddress = item.value || item.address || '';
          } else if (this.currentCoordType === 'dest') {
            this.searchForm.destCoord = coord;
            this.searchForm.destAddress = item.value || item.address || '';
          }

          // 在地图上添加标记
          this.map.clearMap();
          new AMap.Marker({
            position: [lng, lat],
            title: item.value,
            map: this.map
          });

          return;
        }
      }

      // 如果没有位置信息，调用搜索方法
      this.searchLocation();
    },
    // 根据经纬度获取地址
    getAddress(lng, lat) {
      const coord = `${lng},${lat}`;

      // 根据当前操作类型更新坐标
      if (this.currentCoordType === 'origin') {
        this.searchForm.originCoord = coord;
      } else if (this.currentCoordType === 'dest') {
        this.searchForm.destCoord = coord;
      }

      tiandituReverseGeocode(lng, lat).then((r) => {
        if (r.success && r.des) {
          const address = r.des;
          if (this.currentCoordType === 'origin') this.searchForm.originAddress = address;
          if (this.currentCoordType === 'dest') this.searchForm.destAddress = address;
          this.map.clearMap();
          new AMap.Marker({
            position: [lng, lat],
            title: address,
            map: this.map
          });
          this.$message.success(`已选择坐标: ${coord}`);
        } else {
          this.$message.warning('获取地址失败');
        }
      });
    },
    // 搜索位置
    searchLocation() {
      if (!this.mapSearchText || !window.AMap) return;

      const geocoder = new AMap.Geocoder({
        // Geocoder 不需要传安全密钥
      });

      geocoder.getLocation(this.mapSearchText, (status, result) => {
        if (status === 'complete' && result.geocodes && result.geocodes.length > 0) {
          const location = result.geocodes[0].location;
          const lng = location.getLng();
          const lat = location.getLat();

          // 移动地图到搜索位置
          this.map.setZoomAndCenter(15, [lng, lat], true);

          // 在地图上添加标记
          this.map.clearMap();
          new AMap.Marker({
            position: [lng, lat],
            title: this.mapSearchText,
            map: this.map
          });

          // 更新坐标输入框
          const coord = `${lng},${lat}`;
          if (this.currentCoordType === 'origin') {
            this.searchForm.originCoord = coord;
            this.searchForm.originAddress = this.mapSearchText;
          } else if (this.currentCoordType === 'dest') {
            this.searchForm.destCoord = coord;
            this.searchForm.destAddress = this.mapSearchText;
          }

        } else {
          this.$message.warning('未找到该位置');
        }
      });
    },
    // 格式化预计到达时间
    formatEstimateArriveTime(timestamp) {
      if (!timestamp) return '未知';
      const date = new Date(timestamp);
      return date.toLocaleString('zh-CN');
    },
    // 格式化方向
    formatDirection(drc) {
      if (!drc && drc !== 0) return '未知';
      if (drc === 0) return '正北';
      if (drc > 0 && drc < 90) return '东北';
      if (drc === 90) return '正东';
      if (drc > 90 && drc < 180) return '东南';
      if (drc === 180) return '正南';
      if (drc > 180 && drc < 270) return '西南';
      if (drc === 270) return '正西';
      if (drc > 270 && drc <= 359) return '西北';
      return '未知';
    },
    onGarageApplyVehicle({ vclN, vco }) {
      const plate = vclN != null ? String(vclN).trim() : ''
      if (!plate || !this.requirePlateColor(vco)) return
      const colorRaw = vco != null && String(vco).trim() !== '' ? String(vco).trim() : '2'
      const color = ['1', '2', '3'].includes(colorRaw) ? colorRaw : '2'
      this.searchForm.licensePlate = plate
      this.searchForm.licensePlateColor = color
      const scope = this.$route && this.$route.path ? this.$route.path : undefined
      setScopedLicensePlate(plate, scope)
      setScopedPlateColor(color, scope)
      this.$nextTick(() => {
        const form = this.$refs.searchForm
        if (form && typeof form.clearValidate === 'function') {
          form.clearValidate(['licensePlate', 'licensePlateColor'])
        }
      })
    },
    // 接收父组件传递的数据
    updateRouteData(data) {
      this.routeData = data
      if (this.showGaragePanel && data) {
        this.activeGarageLayoutTab = 'result'
      }
    },
    // 接收外部传入的搜索参数并更新筛选条件
    updateSearchForm(params) {
      if (params) {
        // 更新车牌号
        if (params.vclN) {
          this.searchForm.licensePlate = params.vclN;
        }
        // 更新车牌号颜色
        if (params.vco) {
          this.searchForm.licensePlateColor = String(params.vco);
        }
        // 更新开始时间和结束时间
        if (params.qryBtm && params.qryEtm) {
          this.searchForm.startTime = params.qryBtm;
          this.searchForm.endTime = params.qryEtm;
          // 更新日期选择器
          this.value1 = [new Date(params.qryBtm), new Date(params.qryEtm)];
        }
        // 更新始发地坐标
        if (params.startLonlat) {
          this.searchForm.originCoord = params.startLonlat;
        }
        // 更新目的地坐标
        if (params.endLonlat) {
          this.searchForm.destCoord = params.endLonlat;
        }
        // 更新始发地行政区划编码
        if (params.startAreaCode) {
          this.searchForm.startAreaCode = params.startAreaCode;
        }
        // 更新目的地行政区划编码
        if (params.endAreaCode) {
          this.searchForm.endAreaCode = params.endAreaCode;
        }
      }
    },
  }
}
</script>
<style scoped>
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0 !important;
  font-size: 0.875rem !important;
}
/*
.form-item {
  padding-bottom: 0.2rem !important;

} */
::v-deep .el-range-editor.el-input__inner{
  height: 2.1rem !important;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 0 0 0.5rem !important;
}

.leftjoin-time-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.625rem;
}

/* 调整输入框样式 */
::v-deep .el-input__inner,
::v-deep .el-select__inner,
::v-deep .el-checkbox__label,
::v-deep .el-form-item__error {
  font-size: 0.875rem !important;
  height: 2rem !important;
}

::v-deep .el-checkbox__inner {
  width: 1rem !important;
  height: 1rem !important;
}
</style>

<style scoped>
.leftjoin-root {
  position: relative;
  height: 100%;
  /* z-index: 10; */
}

.main-content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 23rem;
    min-width: 23.5rem;
  max-width: 31.5rem;
  height: 100%;
  overflow-y: hidden;
  transition: width 0.3s ease;
}

.main-content.collapsed {
  width: 0;
  min-width: 0;
  overflow: hidden;
}

/* 侧栏边缘梯形标签：左侧竖直，上下边向右倾斜，右侧竖边较短（clip-path） */
.toggle-btn {
position: absolute;
    top: 25%;
    left: 23.5rem;
    transform: translateY(-44%);
    width: 1.2rem;
    height: 5rem;
    padding: 0;
    background-color: var(--layout-primary, #087dff);
    border: none;
    border-radius: 0 1rem 1rem 0;
    clip-path: polygon(0% 0%, 100% 8%, 100% 92%, 0% 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 11;
    transition: left 0.3s ease, filter 0.2s ease;
    outline: none;
    text-align: center;
}



.toggle-btn i {
  font-size: 0.875rem;
  color: #fff;
}

/* 收起时箭头朝右：梯形水平镜像，贴边一侧仍为竖直长边 */
.toggle-btn.collapsed {
  left: 0;
  clip-path: polygon(0% 0%, 100% 8%, 100% 92%, 0% 100%);
}

.left-panel {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #fffc;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
}

.result-panel--in-tab {
  flex: 1;
  min-height: 0;
  margin-top: 0;
}

/* 表单布局 */
.form-row {
  display: flex;
  gap: 0.9375rem;
  align-items: flex-end;
  margin-bottom: 0.3125rem;
  flex-wrap: wrap;
}

.form-item {
  flex: 1;
  margin-bottom: 0 !important;
  min-width: 10rem;
}

/* 时间输入框布局 */
.time-row {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex-wrap: wrap;
}

.time-input {
  flex: 1;
}

.time-separator {
  margin: 0 0.3125rem;
  color: #606266;
}

/* 复选框布局 */
.checkbox-item {
  display: flex;
  align-items: flex-end;
  gap: 0.9375rem;
  padding-bottom: 0.125rem;
  flex-wrap: wrap;
}




/* 调整按钮样式 */
.single-filter-section {
  flex-shrink: 0;
}

.single-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 1.4rem;
  margin: 0.375rem 0 0;
  padding: 0;
  border: 1px solid var(--layout-primary, #087dff);
  border-radius: 0.375rem;
  background: #fff;
  color: var(--layout-primary, #087dff);
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.single-filter-toggle:hover {
  background: var(--layout-primary-soft, rgba(8, 125, 255, 0.08));
  border-color: var(--layout-primary-light, #4da3ff);
  color: var(--layout-primary-hover, #0670e6);
}

.single-filter-toggle i {
  font-size: 1rem;
  line-height: 1;
}

.single-filter-toggle__text {
  font-size: 0.8125rem;
  line-height: 1;
}

.single-filter-search-item {
  margin-bottom: 0.8rem;
}

.single-filter-search-item >>> .el-form-item__content {
  line-height: normal;
}

.search-btn {
  width: 100%;
  margin-top: 0.625rem;
  height: 2.25rem;
  font-size: 0.875rem;
  background-color: var(--layout-primary, #087dff);
}

.result-panel {
  padding: 0.9375rem;
  border-radius: 0.5rem;
  box-shadow: 0.3125rem 0 0.625rem rgba(0, 0, 0, 0.3);
  flex: 1;
  overflow-y: auto;
  margin-bottom: 0;
}

.result-panel--in-tab {
  flex: 1;
  min-height: 0;
  margin-top: 0;
}

.leftjoin-garage-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 0.25rem;
}

.leftjoin-garage-tabs >>> .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.leftjoin-garage-tabs >>> .el-tab-pane {
  min-height: 14rem;
}

.result-title {
  font-size: 1rem;
  line-height:2.25rem;
  color: #333;
  text-decoration: underline;
  text-decoration-color: var(--layout-primary, #087dff);
  text-decoration-thickness: 0.125rem;
  text-underline-offset: 0.25rem;
}


.result-panel h3 {
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  color: #303133;
}

.result-panel .result-item {
  margin-bottom: 0.625rem;
  font-size: 0.875rem !important;
}

/* 地图弹窗样式 */
.map-dialog-content {
  height: 50vh;
  position: relative;
}

.map-search {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 9999;
  background-color: white;
  padding: 0.5rem;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
}

/* 确保下拉框显示在最上层 */
::v-deep .el-autocomplete__suggestions {
  z-index: 10000 !important;
}

.map-container {
  width: 100%;
  height: 100%;
}

.leftjoin-map-prewarm {
  position: fixed;
  left: -625rem;
  top: 0;
  width: 64rem;
  height: 40rem;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}

.leftjoin-map-singleton-el {
  width: 100%;
  height: 100%;
}

/* 危化运单信息卡片（getBillInfo） */
.leftjoin-bill-card-wrap {
  padding: 0 0.9375rem 0.75rem;
  box-sizing: border-box;
}

.leftjoin-bill-card {
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid #e4e7ed;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  background: #fff;
}

.leftjoin-bill-card__header {
  background: #e8edf4;
  padding: 0.75rem 1rem;
}

.leftjoin-bill-card__plate {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--layout-primary, #087dff);
  line-height: 1.3;
}

.leftjoin-bill-card__body {
  padding: 0.75rem 1rem 0.875rem;
  background: #fff;
}

.leftjoin-bill-card__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.55;
}

.leftjoin-bill-card__row:last-child {
  margin-bottom: 0;
}

.leftjoin-bill-card__label {
  color: #606266;
  flex: 0 0 auto;
  padding-right: 0.25rem;
}

.leftjoin-bill-card__value {
  color: #303133;
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

</style>
